<app-menu>
    <ag-grid-angular *ngIf="gridReady"
    style="width: 100%; height: 100%;"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [rowData]="warehouses"
    [class]="themeClass"
    (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</app-menu>